import { render, staticRenderFns } from "./EventSettings.vue?vue&type=template&id=55f5af68&scoped=true"
import script from "./EventSettings.vue?vue&type=script&lang=js"
export * from "./EventSettings.vue?vue&type=script&lang=js"
import style0 from "./EventSettings.vue?vue&type=style&index=0&id=55f5af68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f5af68",
  null
  
)

export default component.exports